import { jsx as e } from "react/jsx-runtime";
function t(l) {
  return /* @__PURE__ */ e("svg", { height: "1em", viewBox: "0 0 20 20", width: "1em", xmlns: "http://www.w3.org/2000/svg", ...l, children: /* @__PURE__ */ e(
    "path",
    {
      d: "M17.075 17.075A9.974 9.974 0 0020 10a9.976 9.976 0 00-2.925-7.075A9.974 9.974 0 0010 0a9.976 9.976 0 00-7.075 2.925A9.974 9.974 0 000 10a9.976 9.976 0 002.925 7.075A9.974 9.974 0 0010 20a9.976 9.976 0 007.075-2.925zm-5.722-3.218c0-.75-.603-1.352-1.353-1.352s-1.371.603-1.371 1.352c0 .75.621 1.372 1.371 1.372s1.353-.622 1.353-1.372zM10 11.133c-.494 0-.86-.402-.914-.914l-.457-4.076C8.556 5.43 9.305 4.77 10 4.77s1.444.659 1.353 1.372l-.439 4.076c-.055.512-.42.914-.914.914z",
      fill: "#9F1300",
      fillRule: "evenodd"
    }
  ) });
}
export {
  t as default
};
